import React, { useEffect, useState } from 'react'
import Text from '../../components/text/Text'
import back from '../../assets/icons/icons-arrow-back.svg'
import './BillingMain.css'
import ModalComponent from '../../components/modal/ModalComponent'
import { useNavigate } from 'react-router-dom'
import routes from '../../router/routes'
import { useLoadingContext } from '../../context/spinnerContext'
import { getBillingHistoryInfo } from '../../services/billing'
import moment from 'moment'
import billingDoc from '../../assets/icons/billing-doc.png'
import { formatCurrency } from '../../utils'

interface IHistoryBilling {
    comisionAvance: number
}

interface ITotalAmount {
    totalAbonos: string | undefined
    totalCargos: string | undefined
    pendienteReembolso: string | undefined
}

interface IMovements {
    abono: string | undefined
    codLocal: string | undefined
    conciliacion1: string | undefined
    conciliacion2: string | undefined
    descripcion: string | undefined
    documento: string | undefined
    estado: string | undefined
    fecha: string | undefined
    fechaRecepcion: string | undefined
    monto: string | undefined
    tipoDocumento: string | undefined
    tipoMovimiento: string | undefined
    cargo: string | undefined
}

const BillingMain = () => {
    const loadingContext = useLoadingContext()
    const navigation = useNavigate()
    const [showDetailModal, setShowDetailModal] = useState(false)
    const [historyBillingInfo, setHistoryBillingInfo] =
        useState<IHistoryBilling | null>(null)
    const [totalAmount, setTotalAmount] = useState<ITotalAmount>()
    const [billingMovements, setBillingMovements] = useState<IMovements[]>([])
    const [selectedMovement, setSelectedMovement] = useState<IMovements | null>(
        null
    )
    console.log(
        'selectedMovement selectedMovement selectedMovement',
        selectedMovement
    )

    const getHistoryInfo = async () => {
        try {
            loadingContext?.onOpen()
            const resp = await getBillingHistoryInfo()
            const info = resp.body.data

            const totales = info.totales
            const list = info.movements
            setTotalAmount(totales)
            setHistoryBillingInfo(info)
            setBillingMovements(list)
        } catch (err) {
            console.error('Error al cargar el historial de facturación:', err)
        } finally {
            loadingContext?.onClose()
        }
    }

    useEffect(() => {
        getHistoryInfo()
    }, [])

    const handleDetailNavigation = () => {
        setShowDetailModal(false)
        if (selectedMovement) {
            const movementDetails = {
                fecha: selectedMovement.fecha,
                fechaRecepcion: selectedMovement.fechaRecepcion,
                documento: selectedMovement.documento,
                descripcion: selectedMovement.descripcion,
                abono: selectedMovement.abono,
                monto: selectedMovement.monto,
                conciliacion1: selectedMovement.conciliacion1,
                tipoDocumento: selectedMovement.tipoDocumento,
                tipoMovimiento: selectedMovement.tipoMovimiento,
                estado: selectedMovement.estado,
            }
            selectedMovement?.descripcion?.includes('Consumo')
                ? navigation(`/${routes.billingDocumentExtended}`, {
                      state: { movementDetails },
                  })
                : selectedMovement?.descripcion === 'Pago'
                ? navigation(
                      `/facturacion/details?nDocumento=${
                          selectedMovement.documento || ''
                      }&nConciliacion=${
                          selectedMovement.conciliacion1 ||
                          selectedMovement.conciliacion2 ||
                          ''
                      }&tipoDocumento=${
                          selectedMovement.tipoDocumento || ''
                      }&tipoMovimiento=${selectedMovement.tipoMovimiento}`
                  )
                : navigation(`/${routes.billingDocument}`, {
                      state: { movementDetails },
                  })
        }
    }
    const documentDetailModal = () => {
        const formatedDate = selectedMovement
            ? moment(selectedMovement.fecha, 'DD-MM-YYYY HH:mm:ss').format(
                  'DD-MM-YYYY'
              )
            : '-'

        return (
            <ModalComponent
                show={showDetailModal}
                handleClose={() => setShowDetailModal(false)}
                icon={true}
                modalStyle="modal-style"
                title="Detalle"
                titleMarginLeft={20}
            >
                <div className="detail-modal-container">
                    <div className="flex-direction-row">
                        <Text
                            label={'Fecha Documento:'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={formatedDate}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    <div className="flex-direction-row">
                        <Text
                            label={'Fecha Recepción:'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={selectedMovement?.fechaRecepcion ?? '-'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    <div className="flex-direction-row">
                        <Text
                            label={'N* Documento:'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={selectedMovement?.documento ?? '-'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    <div className="flex-direction-row">
                        <Text
                            label={'Descripción:'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={selectedMovement?.descripcion ?? '-'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    <div className="flex-direction-row">
                        <Text
                            label={'Abono ($):'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={selectedMovement?.abono ?? '-'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    <div className="flex-direction-row">
                        <Text
                            label={'Cargo ($):'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={selectedMovement?.cargo ?? '-'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    <div className="flex-direction-row">
                        <Text
                            label={'N* Conciliación:'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            lineHeight={3}
                            marginRight={5}
                        />
                        <Text
                            label={selectedMovement?.conciliacion1 ?? '-'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#0086D6'}
                        />
                    </div>
                    {(selectedMovement?.descripcion === 'Proforma' ||
                        selectedMovement?.descripcion === 'Comisión' ||
                        selectedMovement?.descripcion?.includes('Consumo') ||
                        selectedMovement?.descripcion === 'Pago') && (
                        <div
                            className="billing-modal-button"
                            onClick={handleDetailNavigation}
                        >
                            <Text
                                label={'Ver más información'}
                                fontSize={14}
                                fontWeight={600}
                                color={'white'}
                            />
                        </div>
                    )}
                </div>
            </ModalComponent>
        )
    }

    const handleDescriptionClick = (movement: IMovements) => {
        setSelectedMovement(movement)
        setShowDetailModal(true)
    }

    const handleGoBack = () => {
        navigation('/facturacion')
    }

    return (
        <div>
            <div>
                {billingMovements.length === 0 ? (
                    <div className="billing-img-container">
                        <img src={billingDoc} className="billing-img" />
                        <Text
                            label="Datos no disponibles"
                            fontSize={24}
                            fontWeight={600}
                            textAlign={'center'}
                            marginTop={10}
                        />
                    </div>
                ) : (
                    <>
                        <div className="billing-main-flex-direction">
                            <img src={back} alt="Back" onClick={handleGoBack} />
                            <Text
                                label={'Histórico de facturación'}
                                fontSize={20}
                                fontWeight={600}
                                color={'#656565'}
                                marginLeft={15}
                            />
                        </div>

                        <Text
                            label={'Consolidado'}
                            fontSize={14}
                            fontWeight={600}
                            color={'#656565'}
                            marginTop={30}
                            marginBottom={20}
                            marginLeft={70}
                        />

                        <div className="billing-amount-text-container">
                            <div>
                                <Text
                                    label={`Total\nabonos:`}
                                    fontSize={12}
                                    fontWeight={600}
                                    color={'#656565'}
                                    marginBottom={10}
                                />
                                <Text
                                    label={formatCurrency(
                                        totalAmount?.totalAbonos
                                    )}
                                    fontSize={12}
                                    fontWeight={600}
                                    color={'#0E1726'}
                                />
                            </div>
                            <div className="vertical-line" />
                            <div>
                                <Text
                                    label={`Total\ncargos:`}
                                    fontSize={12}
                                    fontWeight={600}
                                    color={'#656565'}
                                    marginBottom={10}
                                />
                                <Text
                                    label={formatCurrency(
                                        totalAmount?.totalCargos
                                    )}
                                    fontSize={12}
                                    fontWeight={600}
                                    color={'#0E1726'}
                                />
                            </div>
                            <div className="vertical-line" />
                            <div>
                                <Text
                                    label={`Pendiente por\nreembolsar:`}
                                    fontSize={12}
                                    fontWeight={600}
                                    color={'#656565'}
                                    marginBottom={10}
                                />
                                <Text
                                    label={formatCurrency(
                                        totalAmount?.pendienteReembolso
                                    )}
                                    fontSize={12}
                                    fontWeight={600}
                                    color={'#0E1726'}
                                />
                            </div>
                        </div>

                        <div className="document-container">
                            <Text
                                label={'Fecha de documento'}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginTop={30}
                                marginBottom={10}
                            />
                            <Text
                                label={'Descripción'}
                                fontSize={12}
                                fontWeight={600}
                                color={'#000000'}
                                marginTop={30}
                                marginBottom={40}
                            />
                        </div>

                        {billingMovements.map((movement, index) => {
                            const formattedDate = moment(
                                movement.fecha,
                                'DD-MM-YYYY HH:mm:ss'
                            ).format('DD-MM-YYYY')

                            return (
                                <div key={index} className="document-container">
                                    <Text
                                        label={formattedDate}
                                        fontSize={12}
                                        fontWeight={400}
                                        color={'#000000'}
                                        marginBottom={10}
                                    />

                                    <div
                                        onClick={() =>
                                            handleDescriptionClick(movement)
                                        }
                                        className="pointer"
                                    >
                                        <Text
                                            label={movement.descripcion}
                                            fontSize={12}
                                            fontWeight={400}
                                            color={'#000000'}
                                            marginBottom={50}
                                        />
                                    </div>
                                </div>
                            )
                        })}

                        {documentDetailModal()}
                    </>
                )}
            </div>
        </div>
    )
}

export default BillingMain
